if (!customElements.get('product-details-accordion')) {
  customElements.define(
    'product-details-accordion',
    class ProductDetailsAccordion extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.items = [...this.querySelectorAll('.product-details-accordion__item')];

        this.items.forEach((item) => {
          const trigger = item.querySelector('.product-details-accordion__trigger');
          const panel = item.querySelector('.product-details-accordion__panel');
          const inner = item.querySelector('.product-details-accordion__inner');
          if (!trigger || !panel || !inner) return;

          if (item.classList.contains('is-open')) panel.style.maxHeight = `${inner.scrollHeight}px`;
          trigger.addEventListener('click', () => this.toggleItem(item));

          if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(() => {
              if (item.classList.contains('is-open')) panel.style.maxHeight = `${inner.scrollHeight}px`;
            });
            observer.observe(inner);
          }
        });
      }

      toggleItem(item) {
        const trigger = item.querySelector('.product-details-accordion__trigger');
        const panel = item.querySelector('.product-details-accordion__panel');
        const inner = item.querySelector('.product-details-accordion__inner');
        const opening = !item.classList.contains('is-open');

        item.classList.toggle('is-open', opening);
        trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
        panel.style.maxHeight = opening ? `${inner.scrollHeight}px` : '0px';

        if (opening) window.dispatchEvent(new Event('resize'));
      }
    }
  );
}
